import {Location}     from "../../../shared-gen/Model/Locations/Location";
import {getDefaultID} from "../../core";
import { ContactFun } from "./contact.fun";
import { EntityType } from "../../../shared-gen/Model/Utils/EntityType";

export class LocationFun {

	static createNew(providerID: string): Location {
		return {
			Type: EntityType.Location,
			ID: getDefaultID(),
			ProviderID: providerID,
			Name: '',
			Hash: '',
			CustomID: '',
			Geolocation: { Latitude: 0, Longitude: 0},
			Mietvertragsnummer: '',
			Mieteinheit: '',
			EanCode: '',
			Address: '',
			Contact: ContactFun.createNew(),
			VoucherRights: []
		};
	}

}
